<template>
    <b-container fluid="md">
        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body class="px-0">
                <div v-if="statusCode" class="alert alert-danger">
                    {{statusCode}}: {{notFoundError}}
                </div>
                <div v-else>
                    <div v-if="!loadingImage">
                        <PreLoader/>
                    </div>
                    <b-row>
                        <b-col v-if="!showPages" class="col-lg-12 nopadding">
                            <b-card-text v-if="loadingImage" class="border">
                                <pinch-zoom class="whitebackground"><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100 invoice-image" /></pinch-zoom>
                            </b-card-text>
                        </b-col>                        
                        <b-col v-if="showPages" class="col-lg-10 nopadding">
                            <b-card-text v-if="loadingImage" class="border">
                                <pinch-zoom class="whitebackground"><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100 invoice-image" /></pinch-zoom>
                            </b-card-text>
                        </b-col>
                        <b-col v-if="showPages && windowSize >= 1200" class="col-lg-2 nopadding d-none d-xl-block" align-self="stretch" >
                            <InvoicePages 
                                v-bind:selectedInvoiceId="selectedInvoiceId"
                                v-bind:showVertical="true"
                                @changeInvoiceImage="changeInvoiceImage($event)"
                                @onPagesLoaded="onPagesLoaded($event)"/>
                        </b-col>
                    </b-row>
                    <b-row v-if="showPages && windowSize < 1200" class="d-xs-block d-sm-block d-md-block d-lg-block d-xl-none">
                            <InvoicePages 
                                v-bind:selectedInvoiceId="selectedInvoiceId"
                                v-bind:showVertical="false"
                                @changeInvoiceImage="changeInvoiceImage($event)"
                                @onPagesLoaded="onPagesLoaded($event)"/>
                    </b-row>
                </div>
            </b-card-body>
        </b-collapse>
    </b-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import PreLoader from '@/components/root/Preloader';
    import InvoicePages from './InvoicePages.vue';
    import PinchZoom from 'vue-pinch-zoom';
    import $ from "jquery";

    export default {
        name: "FactuurFoto",
        components: {PreLoader, PinchZoom, InvoicePages},
        data: () => ({
            standardOpen: [0],
            hover: true,
            focusable: true,
            image: '',
            loadingImage: false,
            showPages: true,
            windowSize: $(window).width()
        }),
        props: {
          selectedInvoiceId: null
        },
        computed: {
            ...mapGetters('fmwebapp',['invoice']),
            ...mapGetters('errors', ['statusCode', 'notFoundError'])
        },
        methods: {
            ...mapActions('fmwebapp', ['all', 'find', 'getImage', 'errors']),
            loadImage()
            {
                this.changeInvoiceImage(this.invoice.invoicePicture)
            },
            changeInvoiceImage(invoicePicture)
            {
                this.loadingImage = false

                var vm = this;
                vm.$store.dispatch('errors/clearErrors');

                vm.getImage(
                {
                    resource:"images",
                    filename: invoicePicture
                }
                ).then((response) => {
                    this.loadingImage = true
                    this.image = response;
                })
            },
            onPagesLoaded(nrOfPages)
            {
                this.showPages = nrOfPages > 1;              
            },
            onResize() {
                this.windowSize = $(window).width();
            } 
        },
        created() {
            var vm = this;
            vm.find({
                resource: 'invoices',
                id: this.selectedInvoiceId
            });
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        },
        mounted(){
            this.loadImage();
        }
    }
</script>
<style>
    .expansionPanel{
        border-radius: 0 !important;
    }

    .nopadding {
        padding: 0;
    }

    .whitebackground {
        background-color: transparent !important;
    }

</style>